import React from "react";

export default function Table_Design() {
  return <div>Excel_Tables_Design</div>;
}
